import remoteService from '@/services/remote-service';

export default {
  namespaced: true,
  state: {
    sections: []
  },
  mutations: {
    setSections(state, sections) {
      state.sections = sections;
    }
  },
  getters: {
    sections(state) {
      return state.sections;
    }
  },
  actions: {
    loadSections({ commit }) {
      return remoteService.loadSections().then((response) => {
        commit('setSections', response.data.list);

        return response.data.list;
      });
    }
  }
};
